export function isKvnr(kvnr: string): boolean {
  if (kvnr.length !== 10) return false;
  return !!/[A-Z_]\d{9}/.exec(kvnr);
}

export function isGermanIban(input: string): boolean {
  const CODE_LENGTHS: { [key: string]: number } = { DE: 22 };

  const mod97 = (checkSum: string) => {
    let checksum: string | number = checkSum.slice(0, 2);
    let fragment: string;
    for (let offset = 2; offset < checkSum.length; offset += 7) {
      fragment = String(checksum) + checkSum.slice(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
  };

  const iban = String(input)
    .toUpperCase()
    .replace(/[^\dA-Z]/g, '');
  const code = /^([A-Z]{2})(\d{2})([\dA-Z]+)$/.exec(iban);

  // check syntax and length
  if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
    return false;
  }
  // rearrange country code and check digits, and convert chars to ints
  const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter: string): string => {
    return (letter.charCodeAt(0) - 55).toString();
  });
  // final check
  return mod97(digits) === 1;
}
